import React from "react";
import { useParams } from "react-router-dom";
import SingleFormularRizika from "../../components/admin/singleFormularRizika";

function AdminFormulariRizikaSinglePage(props) {
  const params = useParams();

  return (
    <div className="admin-page-child-wrapper">
      {/* key forsira remount pri prelasku na drugi formular (npr. iz pretrage) —
          komponenta učitava podatke samo pri mount-u */}
      <SingleFormularRizika key={params.id} />
    </div>
  );
}

export default AdminFormulariRizikaSinglePage;
